import React from "react";
import PropTypes from "prop-types";
import BreadcrumbItem from "../component/BreadcrumbItem/BreadcrumbItem";
import Page from "../component/Page/Page";
import TransactionForm from "./component/TransactionForm";

class TransactionNewPage extends React.Component {
  render() {
    const {match, history} = this.props;
    const breadcrumbs = [
      <BreadcrumbItem key={1} title="Rastreabilidade"/>,
      <BreadcrumbItem key={2} title="Lista de Transações" to="/list/transactions"/>,
      <BreadcrumbItem key={3} title="Nova transação" to="#" active={true}/>];
    return (
        <Page title="Nova transação" breadcrumbs={breadcrumbs}>
          <TransactionForm match={match} history={history}/>
        </Page>
    );
  }
}

TransactionNewPage.propTypes = {
  match: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
};

export default TransactionNewPage;


// WEBPACK FOOTER //
// ./src/transaction/TransactionNewPage.js